<template>
  <div class="app-container">
    <div class="card">
      <el-form
        ref="form"
        :model="queryParams"
        :inline="true"
        @keyup.enter.native="handleQuery"
      >
        <el-form-item label="企业名称：">
          <el-input
            v-model="queryParams.customerName"
            placeholder="请输入企业名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="上次建档审核人：">
          <el-input
            v-model="queryParams.lastAuditor"
            placeholder="请输入上次建档审核人"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="变更操作人：">
          <el-input
            v-model="queryParams.operator"
            placeholder="请输入变更操作人"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="变更类型：">
          <el-input
            v-model="queryParams.changeType"
            placeholder="请输入变更类型"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">
            搜 索
          </el-button>
          <el-button icon="el-icon-delete" @click="handleReset">
            重 置
          </el-button>
        </el-form-item>
      </el-form>
      <div style="margin-bottom: 10px">
        <el-button type="primary" icon="el-icon-download" @click="updowning">
          导 出
        </el-button>
      </div>
    </div>
    <div class="mainContainer">
      <!-- 列表 -->
      <div class="table-container">
        <el-table v-loading="loading" :data="tableData" border height="100%">
          <el-table-column
            prop="customerName"
            label="企业名称"
            align="center"
          />
          <el-table-column
            prop="certificateType"
            label="证件类型"
            align="center"
          >
            <template slot-scope="{ row }">
              {{
                row.certificateType == 1
                  ? "营业执照"
                  : row.certificateType == 2
                  ? "医疗执业许可证"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="certificateNumber"
            label="证件编号"
            align="center"
          />
          <el-table-column
            prop="changeType"
            label="变更类型"
            align="center"
          />
          <el-table-column
            prop="beforeContent"
            label="变更前内容"
            align="center"
          />
          <el-table-column
            prop="afterContent"
            label="变更后内容"
            align="center"
          />
          <el-table-column
            prop="lastAuditor"
            label="上次建档审核人"
            align="center"
          />
          <el-table-column prop="operator" label="变更操作人" align="center" />
          <el-table-column
            prop="updateTime"
            label="变更操作时间"
            align="center"
          />
        </el-table>
      </div>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.currPage"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import {
  getChangeLogList, //变更日志记录列表
} from "@/api/appApi/appapi.js";
import { downLoadZip } from "@/utils/zipdownload";
export default {
  name: "",
  data() {
    return {
      queryParams: {
        currPage: 1, // 页码
        pageSize: 10, //每页大小
        customerName: "", // 企业名称
        lastAuditor: "", // 上次建档审核人
        operator: "", // 变更操作人
        changeType: "", // 变更类型
      },

      total: 0,
      loading: false,
      tableData: [], //列表

      dialogVisible: false, //经营管理更新弹窗
    };
  },

  created() {
    if (this.$route.query) {
      console.log(this.$route.query, "this.$route.query");
    }
    this.getList();
  },
  methods: {
    //序号
    indexMethod(index) {
      index + (this.queryParams.currPage - 1) * this.queryParams.pageSize + 1;
    },

    /** 查询列表数据 */
    async getList() {
      this.loading = true;
      let res = await getChangeLogList(this.queryParams);
      this.loading = false;
      if (res.code == "000000") {
        this.tableData = res.content.list;
        this.total = res.content.totalRecords;
      }
    },
    //查询按钮操作
    handleQuery() {
      this.queryParams.currPage = 1;
      this.getList();
    },
    // 重置
    handleReset() {
      Object.assign(this.queryParams, this.$options.data().queryParams);
      this.getList();
    },
    /** 导出 */
    updowning() {
      downLoadZip(
        "/cloudWisdom/cloud/basic/exportChangeLog",
        "xlsx",
        "变更日志导出",
        this.queryParams,
        "app",
        "get"
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>
